import { render, staticRenderFns } from "./ResultsPDFMainView.vue?vue&type=template&id=4c474522"
import script from "./ResultsPDFMainView.vue?vue&type=script&lang=js"
export * from "./ResultsPDFMainView.vue?vue&type=script&lang=js"
import style0 from "./ResultsPDFMainView.vue?vue&type=style&index=0&id=4c474522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports